import { baseApi } from "./baseApi";

const ROUTE_SHIPMENT_BASE_URL = "/route-shipment";

export const RouteShipmentApi = baseApi.injectEndpoints({
  tagTypes: ["RouteShipment"],

  endpoints: (builder) => ({
    addRouteShipment: builder.mutation({
      query: (payload) => ({
        url: ROUTE_SHIPMENT_BASE_URL,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: [{ type: "RouteShipment", id: "LIST" }],
    }),

    listRouteShipments: builder.query({
      query: (params) => ({
        url: ROUTE_SHIPMENT_BASE_URL,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ _id }) => ({ type: "RouteShipment", id: _id })),
              { type: "RouteShipment", id: "LIST" },
            ]
          : [{ type: "RouteShipment", id: "LIST" }],
    }),

    getDDLRouteShipments: builder.query({
      query: (params) => ({
        url: `${ROUTE_SHIPMENT_BASE_URL}/ddl`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ _id }) => ({ type: "RouteShipment", id: _id })),
              { type: "RouteShipment", id: "DDL" },
            ]
          : [{ type: "RouteShipment", id: "DDL" }],
    }),

    getRouteShipmentDetail: builder.query({
      query: (routeId) => `${ROUTE_SHIPMENT_BASE_URL}/${routeId}`,
      providesTags: (_result, _error, id) => [
        { type: "RouteShipment", id },
        { type: "RouteShipment", id: "LIST" },
      ],
    }),

    updateRouteShipment: builder.mutation({
      query: ({ _id, ...body }) => ({
        url: `${ROUTE_SHIPMENT_BASE_URL}/${_id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (_result, _error, { _id }) => [
        { type: "RouteShipment", id: _id },
        { type: "RouteShipment", id: "LIST" },
      ],
    }),

    addRouteStop: builder.mutation({
      query: ({ shipmentId, ...body }) => ({
        url: `${ROUTE_SHIPMENT_BASE_URL}/${shipmentId}/route`,
        method: "POST",
        body,
      }),
      invalidatesTags: (_result, _error, { shipmentId }) => [
        { type: "RouteShipment", id: shipmentId },
        { type: "RouteShipment", id: "LIST" }, // Ensure list is refreshed
      ],
    }),

    listRouteStops: builder.query({
      query: (shipmentId) => ({
        url: `${ROUTE_SHIPMENT_BASE_URL}/${shipmentId}/route`,
      }),
      providesTags: (_result, _error, shipmentId) => [
        { type: "RouteShipment", id: shipmentId },
      ],
    }),

    updateRouteStop: builder.mutation({
      query: ({ shipmentId, stopId, ...body }) => ({
        url: `${ROUTE_SHIPMENT_BASE_URL}/${shipmentId}/route/${stopId}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (_result, _error, { shipmentId }) => [
        { type: "RouteShipment", id: shipmentId },
        { type: "RouteShipment", id: "LIST" }, // Ensure list is refreshed
      ],
    }),
  }),
});

export const {
  useAddRouteShipmentMutation,
  useListRouteShipmentsQuery,
  useLazyListRouteShipmentsQuery,
  useLazyGetDDLRouteShipmentsQuery,
  useGetRouteShipmentDetailQuery,
  useUpdateRouteShipmentMutation,
  useAddRouteStopMutation,
  useListRouteStopsQuery,
  useLazyListRouteStopsQuery,
  useUpdateRouteStopMutation,
} = RouteShipmentApi;